/* eslint-env node */
module.exports = {
  COLOR: {
    RED: '#B53924',
    WHITE: '#FFFFFF',
    BLACK: '#434142',
    ORANGEBG: '#EDE8E2',
  },
};
